import React from 'react';
import { Upload, Space } from 'antd';
import { InboxOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

const UploadDragger = ({ uploadProps, fileList }) => {
	return (
		<div className="upload-dragger-wrapper">
			<Dragger {...uploadProps} className="professional-dragger">
				<div className="dragger-content">
					<div className="upload-icon-wrapper">
						<InboxOutlined className="upload-icon" />
					</div>
					<div className="upload-text-wrapper">
						<p className="upload-title">Drop your Excel file here</p>
						<p className="upload-subtitle">or click to browse</p>
						<div className="upload-info">
							<Space split={<span style={{ color: '#d9d9d9' }}>•</span>}>
								<span>Supported formats: .xlsx, .xls</span>
								<span>Max file size: 10MB</span>
							</Space>
						</div>
					</div>
					{fileList.length > 0 && (
						<div className="file-uploaded-badge">
							<CheckCircleOutlined style={{ color: '#52c41a', marginRight: 6 }} />
							<span>{fileList[0].name}</span>
						</div>
					)}
				</div>
			</Dragger>
		</div>
	);
};

export default UploadDragger;
